<template>
  <div>
    <div class="card" style="min-height: calc(100vh - 180px)">
      <div class="px-2">
        <DateQuerySetter
            btnTitle="Go"
            @onClickGo="onClickGo"
        >
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mr-top-1">
            <label class="form-label">Task Assign to</label>
            <AsyncSelect
                placeholder="Task Assign to"
                v-model="taskAssignId"
                :api-service="fetchContactProfiles"
                :reduce="text => text.id"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mr-top-1">
            <label class="form-label">Campaign / Project</label>
            <AsyncSelect
                placeholder="Project"
                v-model="projectId"
                :api-service="fetchProjects"
                :reduce="text => text.id"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-2 mr-top-1">
            <label class="form-label">Source</label>
            <v-select
                placeholder="Select Source"
                :options="dealSourceList" v-model="dealSourceId"
                :reduce="option => option.id"
                label="name"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mr-top-1">
            <label class="form-label">Select Owner</label>
            <AsyncSelect
                placeholder="Owner"
                v-model="dealOwnerId"
                :api-service="fetchContactProfiles"
                :reduce="text => text.id"
                :additional-query="{ type: 'contact_owner' }"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mr-top-1">
            <label class="form-label">Select Assign to</label>
            <AsyncSelect
                placeholder="Assign to"
                v-model="dealAssignId"
                :api-service="fetchContactProfiles"
                :reduce="text => text.id"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mr-top-1">
            <label class="form-label">Select Stage</label>
            <v-select
                placeholder="Select Stage"
                :options="dealStageList"
                v-model="dealStageId"
                :reduce="option => option.id"
                label="name"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mr-top-1">
            <label class="form-label">Business Unit</label>
            <v-select
                placeholder="Select Business"
                v-model="businessId"
                :options="business"
                label="name"
                :reduce="name => name.id"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mr-top-1">
            <label class="form-label">Tag Register List</label>
            <AsyncSelect
                placeholder="Tag Register List"
                v-model="tagIds"
                :api-service="fetchTagRegister"
                :reduce="text => text"
                :is-multiple="true"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mr-top-1">
            <label class="form-label"> Product/Service </label>
            <AsyncSelect
                placeholder="Select Product/Service"
                :api-service="fetchProductList"
                v-model="productIds"
                label="text"
                :reduce="text => text"
                :format-label="option => option.text"
                :multiple="true"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3">

            <div class="d-flex align-items-center justify-content-between filter-label">
              <label for="colFormLabel" class="col-form-label">Party: </label>
              <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                            <i class="fas fa-search"></i>
                        </span>
            </div>

            <AsyncSelect
                placeholder="Select Party"
                v-model="contactProfile"
                :api-service="fetchContactProfiles"
                :additional-query="additionalContactOption"
                :reduce="text => text.id"
            />
          </div>

        </DateQuerySetter>
      </div>

      <div class="col-12 px-2">
        <div class="card pipeline-list p-2">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr>
                <th>Customer Details</th>
                <th>Title</th>
                <th>Open Date</th>
                <th>Number</th>
                <th>Source</th>
                <th>Required Product / Services</th>
                <th>Assign To</th>
                <th>Stage</th>
                <th>Description</th>
                <th>Tag</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in pipelineList" :key="index">
                <td>
                  <p><strong>{{ item.contact_profile_name }}</strong></p>
                  <p>{{ item.contact_profile_location }}</p>
                  <p>{{ item.contact_profile_phone }}</p>
                </td>
                <td>{{ item.deal_title }}</td>
                <td>{{ item.created_at.split('T')[0] }}</td>
                <td>{{ item.deal_number }}</td>
                <td>
                  <p><strong>Source - {{ item.deal_source_name }}</strong></p>
                  <p>Campaign / Project - {{ item.project_name }}</p>
                  <p>Deal Owner - {{ item.deal_owner_name }}</p>
                </td>
                <td>
                  <p>Product - {{ getCommaData(item.products) }}</p>
                  <p>Est Deal Value: {{ item.est_deal_value }}</p>
                  <p>Probability (%) of winning - {{ item.probability }}</p>
                </td>
                <td>{{ item.deal_assign_name }}</td>
                <td>{{ item.deal_stage_name }}</td>
                <td>{{ item.description }}</td>
                <td>{{ getCommaData(item.tag_registers) }}</td>
                <td>
                  <button class="btn btn-primary btn-sm"
                          @click="goToEdit(item.id)"
                          style="cursor: pointer"
                  >
                    <i class="fas fa-eye"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>

            <p v-if="!pipelineList.length" class="text-center mt-5">No data</p>
          </div>
        </div>

        <div class="px-2 bottom-0 mt-2">
          <Pagination
              :offset="offset"
              @onPageChange="onPageChange"
              ref="pagination"
          />
        </div>
      </div>

      <ContactDropdownFilter
          v-if="store.state.isModalOpenThree"
          @onSearchContact="onSearchContact"
          :companyRoles="companyRoles"
          :isFilterable="true"
      />

      <Loader v-if="loading"/>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, computed, inject, watch} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from "vuex";
import Loader from "@/components/atom/LoaderComponent.vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import Pagination from '@/components/atom/Pagination';
import handleContact from "@/services/modules/contact";
import handleProjects from "@/services/modules/procurement/project";
import handlePurchase from '@/services/modules/purchase';
import handleTagRegister from '@/services/modules/scm/tag-register';
import handleHospital from '@/services/modules/hospital';
import handleAdmin from '@/services/modules/admin/admin';
import ContactDropdownFilter from '@/components/atom/Contact/ContactDropdownFilter.vue'
import handleRole from "@/services/modules/role";
import handleCBusinesses from '@/services/modules/businesses'

const { fetchContactProfiles } = handleContact();
const { fetchProjects } = handleProjects();
const { fetchProductList } = handlePurchase();
const { fetchTagRegister } = handleTagRegister();
const { fetchNoteMasterList } = handleHospital();
const { fetchPipelineList } = handleAdmin();
const { fetchCompanyDefaultRoles } = handleRole();
const {fetchBusinessList} = handleCBusinesses()

const route = useRoute();
const router = useRouter();
const store = useStore();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false);

const start = computed(() => route.query.start);
const end = computed(() => route.query.end);
const page = computed(() => route.query.page);
const companyId = computed(() => route.params.companyId);

const dealStageList = ref([]);
const dealSourceList = ref([]);
const pipelineList = ref([]);
const offset = ref(10);

const taskAssignId = ref(null);
const projectId = ref(null);
const dealSourceId = ref(null);
const contactProfile = ref(null);
const dealOwnerId = ref(null);
const dealAssignId = ref(null);
const dealStageId = ref(null);
const tagIds = ref([]);
const productIds = ref([]);
const additionalContactOption = ref({
  with_mobile: 1,
  dealer_id: '',
  roles: 'customer,lead'
});
const companyRoles = ref(null);
const businessId = ref(null);
let business = ref([])

const onClickGo = () => {
  getPipelineList();
}

const onOpenContactSearchModal = () => {
  store.state.isModalOpenThree = true;
}

const onPageChange = async (page) => {
  let routeQuery = { ...route.query }
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getPipelineList()
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
}

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onSearchContact = (contact) => {
  contactProfile.value = contact
}

const getDealList = async (noteType, targetList) => {
  const query = `?company_id=${companyId.value}&note_type=${noteType}`;
  try {
    const res = await fetchNoteMasterList(query);
    if (!res.status) {
      return showError(res.message);
    }
    targetList.value = res.data.data;
  } catch (err) {
    console.error(err);
  }
};

const getPipelineList = async () => {
  loading.value = true;
  const query = getQuery();
  try {
    const res = await fetchPipelineList(query);
    if (!res.status) {
      showError(res.message);
      return store.commit("resetPagination")
    }
    pipelineList.value = res.data.data;
    if(pipelineList.value.length > 0) {
      setPagination(res.data)
    }
  } catch (err) {
    console.error(err);
  } finally {
    loading.value = false;
  }
};

const goToEdit = (id) => {
  const params = { ...route.params }
  params.salePipelineId = id;
  const query = { ...route.query }
  query.is_summary = 1;

  router.push({
    name: 'edit-deal',
    params: params,
    query: query,
  })
}

const getCommaData = (data) => {
  if(! data ) {
    return;
  }
  return data.map(p => p.name).join(', ');
}

const getQuery = () => {
  let query = '?company_id=' + companyId.value
  query += '&offset=' + offset.value
  if (start) query += '&start_date=' + start.value
  if (end) query += '&end_date=' + end.value
  if(taskAssignId.value) query += '&task_assign_id=' + taskAssignId.value
  if(projectId.value) query += '&project_master_id=' + projectId.value
  if(dealSourceId.value) query += '&deal_source_id=' + dealSourceId.value
  if(dealOwnerId.value) query += '&deal_owner_id=' + dealOwnerId.value
  if(dealAssignId.value) query += '&deal_assign_id=' + dealAssignId.value
  if(dealStageId.value) query += '&deal_stage_id=' + dealStageId.value
  if(contactProfile.value) query += '&contact_profile_id=' + contactProfile.value
  if (page.value) query += '&page=' + page.value
  if(businessId.value) query += '&business_id=' + businessId.value
  if (productIds.value && productIds.value.length) {
    const ids = productIds.value.map(p => p.id).join(',');
    query += `&product_ids=${ids}`;
  }
  if (tagIds.value && tagIds.value.length) {
    const tags = tagIds.value.map(p => p.id).join(',');
    query += `&tag_ids=${tags}`;
  }
  return query
};

const getCompanyRoles = async () => {
  const res = await fetchCompanyDefaultRoles(`?company_id=${companyId.value}&roles=customer,lead`);
  if (res.status) {
    companyRoles.value = res.data
  }
}

onMounted( () => {
  const query = `?company_id=${route.params.companyId}`;
  const businessRes = fetchBusinessList(query)

  Promise.all([
    getDealList('deal_source', dealSourceList),
    getDealList('deal_stage', dealStageList),
    getPipelineList(),
    getCompanyRoles(),
    businessRes.then(res=> {
      if(res.data) business.value = res.data
    })
  ])
})
</script>

<style scoped>
.mr-top-1 {
  margin-top: 1% !important;
}
.min-height {
  min-height: 150px;
}
#img {
  width: 50px;
}
.card-hover-rise {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.card-hover-rise:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}
.font-bold {
  font-weight: bold;
}
.truncate h4{
  font-size: 30px;
}
.card-head {
  h2 {
    font-weight: bold;
  }
}
</style>